module.exports = __webpack_public_path__ + "static/img/total.b78d257.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/leftOne/total.png
// module id = aTOV
// module chunks = 163